export default __webpack_public_path__ + "static/media/blueClockBold.703c33be.svg";